import styled from 'styled-components'
import { blue, lightGray } from '../../assets/ui/colors';

export const FooterBlock = styled.div`
    display: flex;
    justify-content: space-around;
    background: ${blue};
    height: 64px;
    position: fixed;
    bottom: 0;
    left: ${props => props.leftMargin ? `${props.leftMargin}px` : 0};
    right: 0;
    padding: 0 14px;
    z-index: 1200;
    @media (max-width: 600px) {
        padding: 0;
    }
`;

export const Botton = styled.div`
    display: flex;
    color: white;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    align-items: center;
    text-transform: uppercase;
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
    opacity: ${props => props.disabled ? 0.5 : 1};
    transition: 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    & svg {
        margin: 0 20px;
        @media (max-width: 600px) {
            margin: 0 10px;
        }
    }
    :hover {
        color: ${props => props.disabled ? 'white' : lightGray};
    }
    @media (max-width: 600px) {
        font-size: 12px;
    }
`;
